import api, { globalErrorHandler } from "../Api";
import history from "history.js";

export const SET_APPLY_DATA = "SET_APPLY_DATA";
export const SAVE_JOB_APPLICATION = "SAVE_JOB_APPLICATION";
export const SET_VALIDATIONS = "SET_VALIDATIONS";
export const RE_LOADING = "RE_LOADING";
export const SET_LOADING = "SET_ERROR";

const url = "https://middleware.foundever.com/GOAPI";
export const setApplyData = (payload) => (dispatch) => {
  dispatch({
    type: SET_APPLY_DATA,
    payload: payload,
  });
};

export const setLoading = () => (dispatch) => {
  dispatch({
    type: SET_LOADING,
  });
};

export const saveJobApplication = (payload) => (dispatch) => {
  console.log("payload", payload);
  var formData = new FormData();
  formData.append("email", payload.email);
  formData.append("phone", payload.phone);
  formData.append("badge", payload.badge);
  formData.append("openingId", payload.openingId);
  formData.append("job", payload.job);
  formData.append("workSchedule", payload.workSchedule);
  formData.append("startTime", payload.startTime);
  formData.append("endTime", payload.endTime);

  formData.append("File", payload.resume);
  formData.append("resume", payload.resume.name);
  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };
  dispatch({
    type: RE_LOADING,
  });
  api.defaults.headers.common["Authorization"] =
    "Bearer " + localStorage.getItem("jwt_token");

  api
    .post(`${url}/api/Application`, formData, config)
    .then((res) => {
      dispatch({
        type: SAVE_JOB_APPLICATION,
        payload: res.data,
      });
      if (payload.refresh) {
        history.push({
          pathname: "/",
        });
        history.replace({ pathname: "/growth-opportunities" });
      }
    })
    .catch(globalErrorHandler);
};

export const setValidations = (jobId, jobName, badge) => (dispatch) => {
  api.defaults.headers.common["Authorization"] =
    "Bearer " + localStorage.getItem("jwt_token");
  api
    .post(`${url}/api/Employee/Validate`, {
      jobId: jobId,
      jobName: jobName,
      employeeId: badge,
    })
    .then((res) => {
      dispatch({
        type: SET_VALIDATIONS,
        payload: res.data,
      });
    })
    .catch((error) => {
      // Error
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the
        // browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", error.message);
      }
      console.log(error.config);
    });
};
